export const paymentApi = {
  getPaymentHistory: (returnDays) => ({ url: 'v2/:clientId/payment/v2/history', method: 'post', params: { returnDays } }),
  getSpotMarket: () => ({ url: 'v2/:clientId/payment/v2/spot-market', method: 'get' }),
  getTransactionHistory: (payload) => ({
    url: 'v2/:clientId/payment/v2/transaction-history',
    method: 'post',
    params: { ...payload },
  }),
  getTransactionHistoryOptions: () => ({ url: 'v2/:clientId/payment/v2/category/options', method: 'get' }),
  getPaymentInfo: () => ({ url: `v2/:clientId/payment/v2/payment-info`, method: 'get' }),
  getBindingPaymentInfo: () => ({ url: `v2/:clientId/payment/v2/get-binding-payment-info`, method: 'get' }),
  updatePaymentInfo: ({
    bankCode,
    branch,
    branchCode,
    holderName,
    bankAccount,
    firstNameTh,
    lastNameTh,
    firstNameEn,
    lastNameEn,
    firstNameLocale,
    lastNameLocale,
    bonus,
    paymentProvider,
    pixType,
    bindingType,
    cryptoCurrency,
    cryptoNetwork,
    cryptoAddress,
    walletCode,
    ifscCode,
  }) => ({
    url: 'v2/:clientId/payment/v2/update-payment-info',
    method: 'post',
    params: {
      bankCode,
      branch,
      branchCode,
      holderName,
      bankAccount,
      firstNameTh,
      lastNameTh,
      firstNameEn,
      lastNameEn,
      firstNameLocale,
      lastNameLocale,
      bonus,
      paymentProvider,
      pixType,
      bindingType,
      cryptoCurrency,
      cryptoNetwork,
      cryptoAddress,
      walletCode,
      ifscCode,
    },
  }),
  getBankList: (paymentMethod) => ({ url: `v2/:clientId/payment/v2/${paymentMethod}/get-bank-list`, method: 'get' }),
  getBindingBankList: ({ appSecret }) => ({ url: 'v2/:clientId/payment/v2/get-binding-bank-list', method: 'get', params: { appSecret }, isPublic: true }),
  getBindingPaymentList: ({ appSecret }) => ({ url: 'v2/:clientId/payment/v2/get-binding-payment-list', method: 'get', params: { appSecret }, isPublic: true }),
  getWithdrawBankList: () => ({ url: 'v2/:clientId/payment/v2/get-withdraw-bank-list', method: 'get' }),
  makeTransaction: ({ type, payload, paymentMethod }) => ({
    url: `v2/:clientId/payment/v2/${paymentMethod}/transaction`,
    method: 'post',
    params: {
      transferType: type,
      ...payload,
    },
  }),
  checkTransaction: (paymentMethod) => ({ url: `v2/:clientId/payment/v2/${paymentMethod}/check-transaction`, method: 'post' }),
  setBonusSetting: ({ bonus }) => ({ url: 'v2/:clientId/payment/v2/setting', method: 'post', params: { bonus } }),
  getCurrentWithdrawRule: () => ({ url: 'v2/:clientId/payment/v2/get-current-withdraw-rule', method: 'get' }),
  getDoubleWalletWithdrawRule: ({ walletType }) => ({
    url: 'v2/:clientId/payment/v2/withdraw-rule',
    method: 'post',
    params: { walletType },
  }),
  convertFreeCredit: ({ exchangeType, cryptoNetwork, targetAddress }) => ({
    url: 'v2/:clientId/payment/v2/convert-free-credit',
    method: 'post',
    params: { exchangeType, cryptoNetwork, targetAddress },
  }),
  mergeWallet: () => ({ url: 'v2/:clientId/payment/v2/merge-wallet', method: 'post' }),
  getPaymentDetail: ({ transferType } = {}) => ({
    url: 'v2/:clientId/payment/v2/payment-detail',
    method: 'post',
    params: { transferType },
  }),
  getDepositExpectedResult: ({ method, amount, cryptoCurrency, promotionsNo }) => ({
    url: `v2/:clientId/payment/v2/${method}/expected/result`,
    method: 'post',
    params: { transferType: 'DEPOSIT', amount, cryptoCurrency, promotionsNo },
  }),
  getCryptoDepositExpectedResult: ({ method, amount, cryptoCurrency, promotionsNo }) => ({
    url: `v2/:clientId/payment/v2/${method}/crypto/expected/result`,
    method: 'post',
    params: { transferType: 'DEPOSIT', amount, cryptoCurrency, promotionsNo },
  }),
  getCryptoWithdrawExpectedResult: ({ method, amount, cryptoCurrency, promotionsNo }) => ({
    url: `v2/:clientId/payment/v2/${method}/crypto/expected/result`,
    method: 'post',
    params: { transferType: 'WITHDRAW', amount, cryptoCurrency, promotionsNo },
  }),
  getWithdrawExpectedResult: ({ method, amount, cryptoNetwork }) => ({
    url: `v2/:clientId/payment/v2/${method}/expected/result`,
    method: 'post',
    params: { transferType: 'WITHDRAW', amount, cryptoNetwork },
  }),
  submitDepositTransactionCrypto: ({ method, amount, cryptoCurrency, cryptoNetwork, sourceAddress, promotionsNo, receipt }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: { transferType: 'DEPOSIT', amount, cryptoCurrency, cryptoNetwork, sourceAddress, promotionsNo, receipt },
  }),
  submitDepositTransactionCryptoBank: ({ method, amount, cryptoCurrency, cryptoNetwork, sourceAddress, promotionsNo, depositTime, receipt }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: {
      transferType: 'DEPOSIT',
      amount,
      cryptoCurrency,
      cryptoNetwork,
      sourceAddress,
      promotionsNo,
      depositTime,
      receipt,
    },
  }),
  submitDepositTransactionLoadcard: ({ method, amount, card_type, card_code, card_seri, promotionsNo }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: { transferType: 'DEPOSIT', amount, card_type, card_code, card_seri, promotionsNo },
  }),
  submitDepositTransactionBank: ({
    method,
    amount,
    applyerBankCode,
    applyerAccountNumber,
    applyerIfscCode,
    applyerHolderName,
    applyerBranch,
    applyerBranchCode,
    targetBankCode,
    targetAccountNumber,
    targetIfscCode,
    targetUpi,
    transactionId,
    depositTime,
    receipt,
    promotionsNo,
  }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: {
      transferType: 'DEPOSIT',
      amount,
      applyerBankCode,
      applyerAccountNumber,
      applyerIfscCode,
      applyerHolderName,
      applyerBranch,
      applyerBranchCode,
      targetBankCode,
      targetAccountNumber,
      targetIfscCode,
      targetUpi,
      transactionId,
      depositTime,
      receipt,
      promotionsNo,
    },
  }),
  submitDepositTransaction: ({ method, amount, promotionsNo }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: { transferType: 'DEPOSIT', amount, promotionsNo },
  }),
  submitDepositTransactionCryptoQrcode: ({ method, amount, cryptoCurrency, cryptoNetwork, promotionsNo }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: { transferType: 'DEPOSIT', amount, cryptoCurrency, cryptoNetwork, promotionsNo },
  }),
  submitWithdrawTransactionCrypto: ({ method, amount, cryptoCurrency, cryptoNetwork, targetAddress, applyerHolderName }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: { transferType: 'WITHDRAW', amount, cryptoCurrency, cryptoNetwork, targetAddress, applyerHolderName },
  }),
  submitWithdrawTransactionVN: ({ method, amount, applyerBankCode, applyerAccountNumber, applyerIfscCode, branch, applyerHolderName }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: {
      transferType: 'WITHDRAW',
      amount,
      applyerBankCode,
      applyerAccountNumber,
      applyerIfscCode,
      branch,
      applyerHolderName,
    },
  }),
  submitWithdrawTransactionManual: ({
    method,
    amount,
    applyerBankCode,
    applyerAccountNumber,
    applyerIfscCode,
    branch,
    holderName,
    cryptoCurrency,
    cryptoNetwork,
    targetAddress,
  }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: {
      transferType: 'WITHDRAW',
      amount,
      applyerBankCode,
      applyerAccountNumber,
      applyerIfscCode,
      branch,
      holderName,
      cryptoCurrency,
      cryptoNetwork,
      targetAddress,
    },
  }),
  submitWithdrawTransactionAmb: ({ method, amount }) => ({
    url: `v2/:clientId/payment/v2/${method}/transaction`,
    method: 'post',
    params: { transferType: 'WITHDRAW', amount },
  }),
  getPromotionsList: () => ({ url: `v2/:clientId/payment/v2/bank-wallet/promotions`, method: 'get' }),
  getWithdrawRulePreview: ({ applyType, applyNo, amount, isFreeGame }) => ({
    url: `v2/:clientId/payment/v2/bank-wallet/promotion/preview`,
    method: 'post',
    params: { applyType, applyNo, amount, isFreeGame },
  }),
  applyPromotions: ({ promotionsNo, amount }) => ({
    url: `v2/:clientId/payment/v2/bank-wallet/promotion/apply`,
    method: 'post',
    params: { promotionsNo, amount },
  }),
  giveUp: () => ({ url: 'v2/:clientId/payment/v2/bank-wallet/promotion/give-up', method: 'post' }),
  restore: ({ amount }) => ({ url: 'v2/:clientId/payment/v2/bank-wallet/restore', method: 'post', params: { amount } }),
  getBonusPreview: ({ method, promotionsNo }) => ({
    url: `v2/:clientId/payment/v2/${method}/bonus/preview`,
    method: 'post',
    params: { promotionsNo },
  }),
  getPendingOrder: ({ transferType }) => ({ url: 'v2/:clientId/payment/v2/pending-order', method: 'post', params: { transferType } }),
  withdrawCheck: () => ({ url: `v2/:clientId/payment/v2/withdraw-check`, method: 'post' }),
  updateUtr: ({ applyId, utr }) => ({ url: 'v2/:clientId/payment/v2/update-utr', method: 'post', params: { applyId, utr } }),
  uploadCommonSlip: ({ applyId, slip }) => ({ url: 'v2/:clientId/payment/v2/upload-common-slip', method: 'post', params: { applyId, slip } }),
  inquiryKrwayAccount: (payload) => ({ url: 'v2/:clientId/payment/v2/krway/inquiry', method: 'post', params: payload }),
  getCryptoNetworks: (cryptoCurrency) => ({ url: `v2/:clientId/payment/v2/crypto/networks/${cryptoCurrency}`, method: 'get' }),
  getDepositCryptoInfo: ({ method, network }) => ({ url: 'v2/:clientId/payment/v2/deposit/crypto/info', method: 'post', params: { method, network } }),
}
